module.exports = __webpack_public_path__ + "img/icon-07.c494e68f.png";